import type { CardError } from '~/components/dashboard/DashboardCard';
import { LoadError } from '~/components/ui';

/** What a failed card says in place: the one banner above it holds the reason and the retry (DESIGN.md §7.5). */
export const SECTION_FAILED: CardError = { message: 'See the notice at the top of the page.' };

/** The one banner for a dashboard whose sections load separately: it names the failed ones and offers one retry. */
export function FailedSections({
  failed,
  message = 'The rest of the page is up to date.',
  onRetry,
  testId,
}: {
  failed: string[];
  message?: string;
  onRetry: () => void;
  testId?: string;
}) {
  if (failed.length === 0) return null;
  // English list grammar ("A, B and C"), matching the English copy around it.
  const what = new Intl.ListFormat('en', { type: 'conjunction' }).format(failed);
  return <LoadError what={what} message={message} onRetry={onRetry} testId={testId} />;
}
